module.exports = __webpack_public_path__ + "static/media/YunuenGarciaHerrera.064f5628.jpg";